/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CspUsersRoleFilter { 
    /**
     * Role type filter
     */
    roleType?: string;
    /**
     * Specific role name
     */
    roleName?: string;
    /**
     * Service type for service roles
     */
    serviceType?: string;
}

